export default __webpack_public_path__ + "static/media/2.fafe4ada.jpg";